import { FunctionalComponent, h } from "@stencil/core";

interface SvgLabelProps {
    baseClass: string;
}

export const SvgLabel: FunctionalComponent<SvgLabelProps> = ({ baseClass }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class={`${baseClass}__svg`}
            viewBox="0 0 50 27"
        >
            <rect fill="#ffffff" x="13" y="7.5" width="2" height="12" />
            <circle
                fill="none"
                stroke="#ffffff"
                stroke-width="2"
                cx="36"
                cy="13.5"
                r="6"
            />
        </svg>
    );
};
